import React, { useEffect, useState } from "react";
import GridContainer, { GridOffset } from "@insite/mobius/GridContainer";
import { css } from "styled-components";
import GridItem, { GridItemProps, GridItemStyle } from "@insite/mobius/GridItem";
import Typography, { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import translate from "@insite/client-framework/Translate";
import { CreditCardDtoCollection, removeCreditCardNANew } from "@NA/Services/SavedCreditCardsService";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import getColor from "@insite/mobius/utilities/getColor";
import CustomModelRecap from "./ADICustomModalRecap";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { getProp } from "@insite/mobius/utilities";

export interface AdiEditCreditCardModalStyles {
    editListContainer?: InjectableCss;
    editInputWapper?: InjectableCss;
    labelText?: TypographyPresentationProps;
    valueText?: TypographyPresentationProps;
    primaryButton?: ButtonPresentationProps;
    secondaryButton?: ButtonPresentationProps;
    buttonGridItem?: GridItemProps;
    sectionErrorMsg?: InjectableCss
}

export const adiEditCreditCardModalStyles: AdiEditCreditCardModalStyles = {
    editListContainer: {
        css: css`
            max-width: 582px !important;
            margin-top: 10px;
            > ${GridOffset} {
                > ${GridItemStyle} {
                    display: flex;
                    flex-direction: column;
                    padding-bottom: 0px;
                    padding-top: 10px;
                }
            }
        `,
    },
    labelText: {
        css: css`
            margin-bottom: 2px;
            min-height: 19px;
            font-weight: bold !important;
            line-height: normal;
            color: ${getColor("text.main")};
        `,
    },
    valueText: {
        css: css`
            color: ${getColor("text.accent")};
            line-height: 20px;
            font-size: 14px;
        `,
    },
    editInputWapper: {
        css: css`
            display: flex;
            margin-bottom: 20px;
            width: 100%;
            gap: 15px;
        `,
    },
    buttonGridItem: {
        css: css`
            flex-direction: row !important;
            justify-content: end;
            gap: 10px;
            margin-bottom: 20px !important;
        `,
    },
    primaryButton: {
        css: css`
            border-radius: 4px;
            flex: 1;
        `,
    },
    secondaryButton: {
        css: css`
            border-radius: 4px;
            flex: 1;
        `,
    },
    sectionErrorMsg: {
        css: css`
           color: ${getColor("danger")} ;
           font-size: ${getProp("theme.typography.headerSecondary.size")};
           margin-left: 15px;
        `
    }
};

const styles = adiEditCreditCardModalStyles;

interface OwnProps {
    savedCardData: CreditCardDtoCollection;
    closeDeleteCard: Function;
    getApi: Function;
    isDeleteCardOpen: boolean;
}

type Props = OwnProps;

const ADIDeleteCreditCardModal = ({
    savedCardData,
    isDeleteCardOpen,
    closeDeleteCard,
    getApi,
}: Props) => {

    const [ccErrorMsg , setccErrorMessage] = useState("");
    const [ccNumber, setCCNumber] = useState("");

    useEffect(() =>{
        
        let ccNum = savedCardData.cardNumber.slice(savedCardData.cardNumber.length - 4);
        setCCNumber(ccNum);

    },[savedCardData]);

    const removedSavedCard = async () => {
        // New credit card delete functionality  --- P21 Changes
        if (!savedCardData) return;
        if(savedCardData){
          let ccNum = savedCardData.cardNumber.slice(savedCardData.cardNumber.length - 4);
          setCCNumber(ccNum);
        try {
           const data = savedCardData;
            const result = await removeCreditCardNANew({ data });
            if(result!= undefined && result.result.properties['returnCode'] == "99")
            {
                setccErrorMessage("  There was an error while processing your request.");
                
            }
            else {
            setccErrorMessage("");
            closeDeleteCard();
            getApi();
            }
        } 
        catch (error) {
            throw error;
        }
    }
    };

    
    return (
        <CustomModelRecap
            headline={"Delete Credit Card"}
            isOpen={isDeleteCardOpen}
            errorStyle={false}
            handleClose={closeDeleteCard}
        >
            <>

           
                {savedCardData && (
                    <GridContainer {...styles.editListContainer}>
                        <GridItem width={12}>
                            <Typography variant="p" {...styles.valueText}>
                            {translate("Are you sure you want to delete the card ending in ****")} {ccNumber}
                            </Typography>
                        </GridItem>
                        {ccErrorMsg !== "" && (
                <StyledWrapper {...styles.sectionErrorMsg}>{ccErrorMsg}</StyledWrapper>
           )}
                        <GridItem width={12} {...styles.buttonGridItem}>
                            <Button onClick={() => closeDeleteCard()} variant="secondary" {...styles.secondaryButton}>
                                {translate("Cancel")}
                            </Button>
                            <Button onClick={() => removedSavedCard()} variant="primary" {...styles.primaryButton}>
                                {translate("Delete")}
                            </Button>
                        </GridItem>
                    </GridContainer>
                )}
            </>
        </CustomModelRecap>
    );
};

export default ADIDeleteCreditCardModal;
